'use client';

function mergeRefs(firstRef, secondRef) {
  return (r) => {
    if (typeof firstRef === "function") firstRef(r);
    if (typeof firstRef === "object" && firstRef !== null) {
      firstRef.current = r;
    }
    if (typeof secondRef === "function") secondRef(r);
    if (typeof secondRef === "object" && secondRef !== null) {
      secondRef.current = r;
    }
  };
}
export {
  mergeRefs
};
